export const PRICE_PER_CREDIT = 500; // In Cents for stripe

export const TRANSACTIONS_TYPES = {
    PURCHASED: "PURCHASED",
    TRANSFER_IN: "TRANSFER_IN",
    TRANSFER_OUT: "TRANSFER_OUT",
    "SPENT.INSIGHTS": "SPENT.INSIGHTS",
    "SPENT.PARAMETRIC": "SPENT.PARAMETRIC",
};

export const URL = {
    PARAMETRIC: "/parametric",
    INSIGHTS: "/model",
};
